<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        &nbsp;
      </div>
      <div class="d-flex flex-wrap justify-end flex-gap">
        <v-btn class="ml-6" dark depressed color="#0D47A1" @click="() => $refs['create-popup'].openDialog()">
          <v-icon left>mdi-plus</v-icon>Thêm sự kiện
        </v-btn>
      </div>
    </div>

    <v-card outlined class="pa-6 mx-4 mb-6 elevation-0">
      <EventFilter @onFilterChanged="onFilterChanged" />
    </v-card>

    <v-card outlined class="mx-4 elevation-0">
      <EventTable />
    </v-card>
    <EventCreateDialog ref="create-popup" @done="onFilterChanged" />
  </div>
</template>
<script>
import {mapActions} from 'vuex'
// import Breadcrumbs from '@/components/layout/Breadcrumbs'
import EventFilter from '@/modules/event/EventFilter'
import EventTable from '@/modules/event/EventTable'
import EventCreateDialog from '@/modules/event/EventCreateDialog'

export default {
  components: {
    // Breadcrumbs,
    EventFilter,
    EventTable,
    EventCreateDialog
  },
  methods: {
    ...mapActions({
      search: 'events/search'
    }),
    onFilterChanged(query = {}) {
      this.search(query)
    }
  }
}
</script>
